import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { Reglamentos } from "../../../../shared/Reglamentos";

class Normativa extends Component {

    contenido = () => {

        let styleFont = {
            cursor: "pointer",
            fontSize: 10,
        }

        let archivos = () => {
            return (
                Reglamentos.map (option => (
                    <div className="div-hover" key={option.id}><a className="fuente-monserrat" href={option.href} target="_blank" title="Descargar" style={styleFont}>{option.titulo}</a></div>   
                ))
            )
        }

        let download = (
            <Popover bsSize = "large"
                title={
                    <div style={{fontSize:10, fontWeight:"bold"}} align="center" className="fuente-monserrat">Selecciona el archivo que deseas descargar</div>
                } id="download"
            >
                {archivos()}
            </Popover>
        )
        return(
            <div id="normativas">
                <Timeline>
                    <Event interval="Normativas y Reglamentos">
                        <OverlayTrigger trigger="focus" placement="right" overlay={download}>
                            <button className="btn btn-danger fuente-monserrat"
                                style={{
                                    borderWidth: 1,
                                    backgroundColor:"#a80012",
                                    color:"#FFF",
                                    borderColor:"#a80012",
                                    padding: 7
                            }}>Descargar Archivos</button>
                        </OverlayTrigger>
                    </Event>
                    <Event interval={<a style={{color:"#a80012"}}>Legislación General</a>}>
                        <p>
                            <p className="fuente-monserrat">Ley Orgánica de Educación 2009</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Ley de Universidades 1970</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de los Institutos y Colegios Universitarios</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Ley de Servicio Comunitario del Estudiante de Educación Superior 2005</p>
                        </p>
                    </Event>
                    <Event interval={<a style={{color:"#a80012"}}>Reglamentos IUDLM</a>}>
                        <p> 
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento Interno</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento General de Evaluación del Desempeño Estudiantil IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento Disciplinario Estudiantil IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Trabajo de Grado IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Servicio Comunitario IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Pruebas de Suficiencia IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Pasantías Profesionales IUDLM</p>
                            {/* <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Reconocimiento de Estudios y Pruebas de Suficiencia</p> */}
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Cursos Intensivos IUDLM</p>
                            <p className="fuente-monserrat" style={{marginTop:-20}}>Reglamento de Becas Estudiantiles IUDLM</p>
                        </p>
                    </Event>
                </Timeline>
            </div>
        )
    }

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Normativa;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Normativa.jsx